<template>
    <!--#FF6969-->
    <v-app-bar color="primary " app bottom dark style="top:unset; bottom:0px">
        <v-layout xs12 row>
            <v-container fill-height>
                <v-layout align-center text-center>
                    <v-flex xs4>
                        <v-tooltip fixed top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    :z-index="zindex('btn_insights')"
                                    text
                                    :to="{path:'/dashboard/?home'}"
                                    v-on="on"
                                >
                                    <v-icon v-if="!$vuetify.breakpoint.smAndDown">flash_on</v-icon>&nbsp;&nbsp;INSIGHTS
                                </v-btn>
                            </template>
                            <span>Acompanhe diariamente a evolução dos seus produtos!</span>
                        </v-tooltip>
                    </v-flex>

                    <v-flex xs4>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn :to="{name:'products'}"
                                   text                                   
                                    v-on="on"
                                >
                                    <v-icon v-if="!$vuetify.breakpoint.smAndDown">album</v-icon>&nbsp;&nbsp;PRODUTOS
                                </v-btn>
                            </template>
                            <span>Adicione e gerencie os seus produtos!</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs4>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn text :to="{name:'works'}"
                                 v-on="on"
                                >
                                    <v-icon v-if="!$vuetify.breakpoint.smAndDown">waves</v-icon>&nbsp;&nbsp;OBRAS
                                </v-btn>
                            </template>
                            <span>Adicione e gerencie as obras!</span>
                        </v-tooltip>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
    </v-app-bar>
    <!--v-toolbar  floating short color="primary" dark>
        <v-layout xs12 row>
            <v-container fill-height>
                <v-layout align-center text-center>
                    <v-flex xs4>
                        <v-btn
                            :z-index="zindex('btn_insights')"
                            text
                            :to="{path:'/dashboard/?home'}"
                        >
                            <v-icon>flash_on</v-icon>INSIGHTS
                        </v-btn>
                    </v-flex>
                  
                    <v-flex xs4>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    color="orange darken-2"
                                    elevation="0"
                                    v-on="on"
                                    large
                                    :to="{name:'products'}"
                                >
                                    <v-icon>album</v-icon>PRODUTOS
                                </v-btn>
                            </template>
                            <span>Left tooltip</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs4>
                        <v-btn text :to="{name:'works'}">
                            <v-icon>waves</v-icon>OBRAS
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
    </v-toolbar-->
</template>
<script>
import { mapGetters } from "vuex";

export default {
    data: () => ({
        //
    }),
    computed: {
        ...mapGetters(["wizard"])
    },
    methods: {
        zindex(component) {
            var zindex =
                this.wizard.components_zindexed.indexOf(component) >= 0 ? 0 : 1;
            console.log("zindex", zindex);
            return zindex;
        }
    }
};
</script>
